module.exports = __webpack_public_path__ + "media/icons/circular300-c60c98c4.png";